import swal from "sweetalert";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";
import { productActions } from "../../../_store";
import Toastr from "../../components/common/Toastr";

export const HandleArchiveProduct = (
  values,
  startEndDate,
  warningText,
  WCStatus,
  dispatch,
  showLoader,
  hideLoader,
  status
) => {
  swal({
    title: warningText,
    text: "",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then((res) => {
    if (res) {
      showLoader();
      const ApiData = {
        status: WCStatus,
      };

      if (values.IsGemar === true && values.IsPartyDeco === true) {
        UpdateProductGemarAndPA(
          values,
          startEndDate,
          ApiData,
          dispatch,
          hideLoader,
          status
        );
      } else if (values.IsGemar === true) {
        UpdateProductGemar(
          values,
          startEndDate,
          ApiData,
          dispatch,
          hideLoader,
          status
        );
      } else if (values.IsPartyDeco === true) {
        UpdateProductPA(
          values,
          startEndDate,
          ApiData,
          dispatch,
          hideLoader,
          status
        );
      } else {
        hideLoader();
        Toastr("Data error", "warning");
      }
    }
  });
};

function UpdateProductGemar(
  values,
  startEndDate,
  ApiData,
  dispatch,
  hideLoader,
  status
) {
  restApi
    .post("products/" + values.WCProductID, ApiData)
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 201 ||
        !response.statusText
      ) {
        dispatch(
          productActions.handleArchive({
            productID: values?.ProductID,
            status: status,
          })
        );

        dispatch(
          status === 1
            ? productActions.archivedProduct()
            : productActions.getProductAll(startEndDate)
        );
        Toastr(
          `Product has been ${
            status === 4 ? "archived" : "unarchived"
          } successfully`,
          "success"
        );
        hideLoader();
      } else {
        hideLoader();
        Toastr("Gemar : " + response.statusText, "warning");
      }
    })
    .catch((error) => {
      hideLoader();
      let msg = error.response ? error.response.data.message : "rest Api error";
      Toastr("Gemar : " + msg, "warning");
    });
}

function UpdateProductPA(
  values,
  startEndDate,
  ApiData,
  dispatch,
  hideLoader,
  status
) {
  restApi_PD
    .post("products/" + values.PDWCProductID, ApiData)
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 201 ||
        !response.statusText
      ) {
        dispatch(
          productActions.handleArchive({
            productID: values?.ProductID,
            status: status,
          })
        );
        dispatch(
          status === 1
            ? productActions.archivedProduct()
            : productActions.getProductAll(startEndDate)
        );
        Toastr(
          `Product has been ${
            status === 4 ? "archived" : "unarchived"
          } successfully`,
          "success"
        );
        hideLoader();
      } else {
        hideLoader();
        Toastr("PartyDeco : " + response.statusText, "warning");
      }
    })
    .catch((error) => {
      hideLoader();
      let msg = error.response ? error.response.data.message : "rest Api error";
      Toastr("PartyDeco : " + msg, "warning");
    });
}

function UpdateProductGemarAndPA(
  values,
  startEndDate,
  ApiData,
  dispatch,
  hideLoader,
  status
) {
  restApi
    .post("products/" + values.WCProductID, ApiData)
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 201 ||
        !response.statusText
      ) {
        restApi_PD
          .post("products/" + values.PDWCProductID, ApiData)
          .then((PDResponse) => {
            if (
              PDResponse.status === 200 ||
              PDResponse.status === 201 ||
              !PDResponse.statusText
            ) {
              dispatch(
                productActions.handleArchive({
                  productID: values?.ProductID,
                  status: status,
                })
              );

              dispatch(
                status === 1
                  ? productActions.archivedProduct()
                  : productActions.getProductAll(startEndDate)
              );

              Toastr(
                `Product has been  ${
                  status === 4 ? "archived" : "unArchived"
                } successfully`,
                "success"
              );
              hideLoader();
            } else {
              hideLoader();
              Toastr("PartyDeco : " + PDResponse.statusText, "warning");
            }
          })
          .catch((error) => {
            hideLoader();
            let msg = error.response
              ? error.response.data.message
              : "rest Api error";
            Toastr("PartyDeco : " + msg, "warning");
          });
      } else {
        hideLoader();
        Toastr("Gemar : " + response.statusText, "warning");
      }
    })
    .catch((error) => {
      hideLoader();
      let msg = error.response ? error.response.data.message : "rest Api error";
      Toastr("Gemar : " + msg, "warning");
    });
}
